function Logout({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14 5L12.59 6.41L14.17 8H6V10H14.17L12.59 11.58L14 13L18 9L14 5ZM2 2H9V0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H9V16H2V2Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Logout;
